import { createFileRoute } from '@tanstack/react-router';
import {
  tenantRequestListScreen,
  tenantRequestListSearch,
  loadTenantRequestMessages,
  loadTenantRequestScreens,
} from '@/modules/tenant-request/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/parceiros/solicitacoes/')({
  validateSearch: tenantRequestListSearch,
  staticData: { screen: tenantRequestListScreen },
  loader: loadTenantRequestMessages,
  component: lazyScreen(loadTenantRequestScreens, 'TenantRequestListPage'),
});
